import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as DestinationActions from '../actions/destination.actions';
import { DestinationsService } from '../../../services/api/destinations/destinations.service';
import {Destination} from '../../../services/api/destinations/destination.model';



@Injectable()
export class DestinationEffects {

  // noinspection JSUnusedGlobalSymbols
  loadDestination$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DestinationActions.loadDestination),
      concatMap((payload) =>
        this.destinationsService.getDestination(payload.id).pipe(
          map((data: Destination) => DestinationActions.loadDestinationSuccess({ data })),
          catchError((error: any) => of(DestinationActions.loadDestinationFailure({ error }))))
      )
    );
  });



  constructor(
    private readonly actions$: Actions,
    private readonly destinationsService: DestinationsService
  ) {}

}
